/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_APPLICATION_DATA (state, settings) {
    state.settings = settings
  },
  // GENERAL
  SET_FAVICON(state, favicon) {
    state.settings.favicon = favicon
  },
  SET_TAB_NAME(state, tabName) {
    state.settings.tabName = tabName
  },
  SET_FOOTER(state, footer) {
    state.settings.footer = footer
  },
  SET_TELEGRAM_WELCOME_MESSAGE(state, telegramWelcomeMessage) {
    state.settings.telegramWelcomeMessage = telegramWelcomeMessage
  },
  SET_TELEGRAM_BOT_TOKEN(state, telegramBotToken) {
    state.settings.telegramBotToken = telegramBotToken
  },
  SET_API_DELEGATOR(state, apiDelegator) {
    state.settings.apiDelegator = apiDelegator
  },
  SET_API_INTEGRATION_TOKEN(state, apiIntegrationToken) {
    state.settings.apiIntegrationToken = apiIntegrationToken
  },
  SET_CAN_SIMULTANEOUS_SESSIONS(state, canSimultaneousSessions) {
    state.settings.simultaneousSessions = canSimultaneousSessions
  },
  SET_LOGICAL_EXCLUSION(state, logicalExclusion) {
    state.settings.logicalExclusion = logicalExclusion
  },
  // LOGIN
  SET_BACKGROUND(state, background) {
    state.settings.background = background
  },
  SET_CARD_LOGO(state, cardLogo) {
    state.settings.logo = cardLogo
  },
  SET_CARD_IMAGE(state, cardLogo) {
    state.settings.cardLogo = cardLogo
  },
  SET_TAB_NAME_LOGIN(state, title) {
    state.settings.tabTitle = title
  },
  SET_USERNAME_LABEL(state, usernameLabel) {
    state.settings.usernameLabel = usernameLabel
  },
  SET_FORGOT_LABEL(state, forgotLabel) {
    state.settings.forgotLabel = forgotLabel
  },
  SET_FORGOT_PASSWORD_BUTTON_LABEL(state, forgotPasswordButtonLabel) {
    state.settings.forgotPasswordButtonLabel = forgotPasswordButtonLabel
  },
  SET_TITLE(state, title) {
    state.settings.title = title
  },
  SET_PASSWORD_LABEL(state, passwordLabel) {
    state.settings.passwordLabel = passwordLabel
  },
  SET_FORGOT_PASSWORD_TITLE(state, forgotPasswordTitle) {
    state.settings.forgotPasswordTitle = forgotPasswordTitle
  },
  SET_SUBTITLE(state, subtitle) {
    state.settings.subtitle = subtitle
  },
  SET_SUBMIT_LABEL(state, submitLabel) {
    state.settings.submitButtonText = submitLabel
  },
  SET_FORGOT_PASSWORD_EMAIL_LABEL(state, forgotPasswordEmailLabel) {
    state.settings.forgotPasswordEmailLabel = forgotPasswordEmailLabel
  },
  //OUTGOING SERVER
  SET_EMAIL_PROTOCOL(state, protocol) {
    state.settings.emailSenderDriverTypeId = protocol
  },
  SET_EMAIL_PORT(state, port) {
    state.settings.emailSenderPort = port
  },
  SET_EMAIL_FROM_NAME(state, fromName) {
    state.settings.emailSenderFromName = fromName
  },
  SET_EMAIL_FROM_HOST(state, host) {
    state.settings.emailSenderHost = host
  },
  SET_EMAIL_FROM_ADDRESS(state, fromAddress) {
    state.settings.emailSenderFromAddress = fromAddress
  },
  SET_EMAIL_USERNAME(state, username) {
    state.settings.emailSenderUsername = username
  },
  SET_EMAIL_PASSWORD(state, password) {
    state.settings.emailSenderPassword = password
  }
}
